import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconSettings = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M500.633 211.454l-58.729-14.443c-3.53-11.133-8.071-21.929-13.55-32.256l27.349-45.571c3.545-5.903 2.607-13.462-2.256-18.325l-42.422-42.422a14.96 14.96 0 0 0-18.325-2.256L347.055 83.53a193.24 193.24 0 0 0-32.065-13.433l-14.443-58.729C298.876 4.688 292.885 0 286 0h-60c-6.885 0-12.891 4.688-14.546 11.367l-14.429 58.715a192.57 192.57 0 0 0-34.043 14.502l-47.329-28.403c-5.918-3.516-13.447-2.607-18.325 2.256l-42.422 42.422c-4.863 4.863-5.801 12.422-2.256 18.325l29.268 48.882c-4.717 9.302-8.672 18.984-11.821 28.901l-58.729 14.487C4.688 213.124 0 219.115 0 226v60c0 6.885 4.688 12.891 11.367 14.546l58.744 14.443c3.56 11.294 8.188 22.266 13.799 32.798l-26.191 43.652c-3.545 5.903-2.607 13.462 2.256 18.325l42.422 42.422c4.849 4.849 12.407 5.771 18.325 2.256l43.755-26.221c10.415 5.552 21.313 10.137 32.549 13.696l14.429 58.715A14.98 14.98 0 0 0 226 512h60c6.885 0 12.876-4.688 14.546-11.367l14.429-58.715c11.558-3.662 22.69-8.394 33.281-14.136l44.443 26.66c5.903 3.53 13.462 2.622 18.325-2.256l42.422-42.422c4.863-4.863 5.801-12.422 2.256-18.325l-26.968-44.927a192.1 192.1 0 0 0 13.169-31.523l58.729-14.443C507.313 298.876 512 292.885 512 286v-60c0-6.885-4.687-12.876-11.367-14.546zM256 361c-57.891 0-105-47.109-105-105s47.109-105 105-105 105 47.109 105 105-47.109 105-105 105z"
    }));

export { IconSettings };
